import { ActionIcon } from "PFComponents/action_icon/action_icon";
import { Ref } from "react";
import { useTranslation } from "react-i18next";

import css from "./propilot_bubble.module.scss";

type ProPilotBubbleProps = {
  isOpen: boolean;
  panelId: string;
  ref?: Ref<HTMLButtonElement>;
  onClick: () => void;
};

export const ProPilotBubble = ({ isOpen, panelId, ref, onClick }: ProPilotBubbleProps) => {
  const { t } = useTranslation("translation");
  const label = t("propilot.bubble.label");

  return (
    <ActionIcon
      ref={ref}
      name="ai-agent"
      size="sm"
      color="paletteWhite0"
      classes={{ root: css.bubble }}
      aria-label={label}
      aria-expanded={isOpen}
      aria-controls={panelId}
      qaId="ProPilotBubble"
      onClick={onClick}
    />
  );
};
